'use client';

import React from 'react';
import { Auth0Provider } from '@/contexts/Auth0Context';
import { LayoutProvider } from '@/contexts/LayoutContext';
import { ThemeProvider } from '@/theme/ThemeProvider';
import { VoiceCommandProvider } from '@/contexts/VoiceCommandContext';
import { InternationalizationProvider } from '@/contexts/InternationalizationContext';

export function ClientProviders({ children }: { children: React.ReactNode }) {
  return (
    <Auth0Provider>
      <InternationalizationProvider>
        <ThemeProvider>
          <LayoutProvider>
            <VoiceCommandProvider>
              {children}
            </VoiceCommandProvider>
          </LayoutProvider>
        </ThemeProvider>
      </InternationalizationProvider>
    </Auth0Provider>
  );
}

